<div>
  @switch (errorCode) {
    @case ('401') {
      <div>
        <h1>Unauthorised</h1>
        <h2>{{message}}</h2>
      </div>
    }
    @case ('400') {
      <div>
        <h1>Invalid Request</h1>
        <h2>{{message}}</h2>
      </div>
    }
    @case ('423') {
      <div>
        <h1>The application is under maintenance</h1>
        <h2>Please come back later</h2>
      </div>
    }
    @case ('404') {
      <div>
        <h1>Page Not Found</h1>
        <h2>{{message}}</h2>
      </div>
    }
  }
</div>
